import React, { useEffect, useState } from "react";
import { Modal, Col, Row } from "react-bootstrap";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { formatDate, getTodaysData } from "../../../../common/Validations";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import ItemServiceV2 from "../../../../services/logistics_appCommonService";
import logistics from "../../../../services/logistics_appCommonService";

import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { getOrderSchedulingList } from "../../../../redux/feature/customer_app/customerV1Slice";
import { getTransportList } from "../../../../redux/feature/logistics_app/logisticsSlice";
import DataTable from "react-data-table-component";

const PlLogisticFuelEntryModal = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const fuelHistoryColum = [
    {
      name: "Fuel No",
      selector: (row) => row?.documentNumber,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-new-status">
            {row.documentNumber}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Filled Date",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">
            {formatDate(row?.filledDate)}{" "}
          </p>
        </div>
      ),
      width: "140px",
    },
    {
      name: "Bunk",
      selector: (row) => row.bunk || "--",
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 text-primary fw-bold">{row.bunk} </p>
          {/* <p className="m-0 p-0">{row.vendorName} </p> */}
        </div>
      ),
    },
    {
      name: "Driver",
      selector: (row) => row.driverName,
      sortable: true,
      width: "100px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.driverName} </p>
          {/* <p className="m-0 p-0">{row.vendorName} </p> */}
        </div>
      ),
    },
    {
      name: "Driver Contact",
      selector: (row) => row.driverContactNr || "--",
      sortable: true,
      width: "150px",
    },

    {
      name: "Liters",
      selector: (row) => row.liters || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Total Amount",
      selector: (row) => row.totalAmount || "--",
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 fw-bold">{row.totalAmount}</p>
            {/* <p className="m-0 p-0">{row.currencyCode}</p> */}
          </div>
        </>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "Payment Mode",
      selector: (row) => row.paymentMode || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Old Reading",
      selector: (row) => row.oldReading || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "New Reading",
      selector: (row) => row.newReading,
      sortable: true,
      width: "130px",
    },
    {
      name: "Usage Reading",
      selector: (row) => row.usageReading,
      sortable: true,
      width: "140px",
    },
    {
      name: "Mileage",
      selector: (row) => Number(row.mileage).toFixed(2),
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {Number(row.mileage).toFixed(2)}
          </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Attachments",
      selector: (row) => row.billDocument,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center"
        >
          {row.billDocument && (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() => handleViewFile(row.billDocument)}
            />
          )}
        </div>
      ),
      sortable: true,
      width: "130px",
    },
  ];

  const PaymentMode = [
    { id: 1, name: "Cash" },
    { id: 2, name: "UPI" },
    { id: 3, name: "Cards(Debit/Credit)" },
  ];

  const bunk = [
    { id: 1, name: "Basaveshwara Fuels" },
    { id: 2, name: "HNS Fuel" },
    { id: 2, name: "RK Fuels" },
  ];
  const FuelType = [
    { id: 1, name: "Petrol" },
    { id: 2, name: "Diesel" },
  ];

  // View attachment files

  const [getData, setData] = useState({});

  const [formInputs, setFormInputs] = useState({});
  const [isCardVisible3, setCardVisible3] = useState(true);

  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const [getDropdownData, setDropdownData] = useState([]);

  const [getEditmode, setEditMode] = useState(false);

  useEffect(() => {
    // console.log(">>props match", props);
    // console.log(">>porps",props)
    loadIntialData();
    setEditMode(props?.data?.fuelEnteryModal === "FUELUPDATED" ? true : false);

    if (props?.data) {
      setData({
        ...props.data,
        fuelEnteryModal: "FUELUPDATED",
      });
      setFormInputs({
        filledDate: getTodaysData() || "",
        truckNo: props?.data?.vehicleNr || "",
        driverName: props?.data?.driverName1 || "",
        driverCode: props?.data?.driverCode || "",
        driverName1Code: props?.data?.driverName1Code || "",

        driverContactNr: props?.data?.driverContactNr || "",
        bunk: props?.data?.bunk || "",
        fuelType: props?.data?.fuelType || "",
        paymentMode: props?.data?.paymentMode || "",
        liters: props?.data?.liters || "",
        price: props?.data?.price || "",
        totalAmount: props?.data?.totalAmount || "",
        odometerReading: props?.data?.odometerReading || "",
        km: props?.data?.km || "",
        mileage: props?.data?.mileage || "",
        billDocument: props?.data?.billDocument || "",
        oldReading: props?.data?.oldReading || "",
        newReading: props?.data?.newReading || "",
        usageReading: props?.data?.usageReading || "",
      });
    }

    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
    // eslint-disable-next-line
  }, [props]);

  useEffect(() => {
    if (getDropdownData?.textField === "bunk") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "fuelType") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
  }, [getDropdownData]);
  //handleVeiw fiel
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  //document upload
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  //handleChange
  const handleInputChange = ({ target: { name, value } }) => {
    // Update form input values
    setFormInputs((prevInputs) => {
      const updatedInputs = { ...prevInputs, [name]: value };

      if (updatedInputs.liters && updatedInputs.price) {
        updatedInputs.totalAmount =
          Number(updatedInputs.liters) * Number(updatedInputs.price);
      } else {
        updatedInputs.totalAmount = "";
      }

      if (updatedInputs.oldReading && updatedInputs.newReading) {
        updatedInputs.usageReading =
          Number(updatedInputs.newReading) - Number(updatedInputs.oldReading);
      } else {
        updatedInputs.usageReading = "";
      }

      if (updatedInputs.usageReading && updatedInputs.liters) {
        updatedInputs.mileage =
          Number(updatedInputs.usageReading) / Number(updatedInputs.liters);
      } else {
        updatedInputs.mileage = "";
      }

      return updatedInputs;
    });
  };
  //handle Save
  const [disabled, setDisabled] = useState(false);
  const handleCancle = () => {
    setFormInputs({
      truckNo: "",
      driverName: "",
      driverContactNr: "",
      bunk: "",
      type: "",
      paymentMode: "",
      liters: "",
      price: "",
      totalAmount: "",
      // odometerReading: "",
      km: "",
      mileage: "",
      billDocument: "",
      oldReading: "",
      newReading: "",
      usageReading: "",
    });
    props?.onHide();
  };
  // const handleSave = async () => {
  //   // setFormInputs((prev) => ({ ...prev }));

  //   let obj = {
  //     data: {...formInputs},
  //   };
  //   setDisabled(true);

  //   await ItemServiceV2.addLogisticsFuel(obj).then((item) => {
  //     if (item?.status === 200) {
  //       // handleSearchFuncApi();
  //       toast.success(item?.message || "added successfully", {
  //         duration: 2000,
  //         position: "top-right",
  //       });
  //       let obj = {
  //         queryName: "getFuelList",
  //         module: "CUSTOMER",
  //         page: 1,
  //         per_page: 10,
  //       };
  //       dispatch(getOrderSchedulingList(obj));
  //       let obj2 = {
  //         queryName: "getLogisticsTransportList",
  //         module: "",
  //         page: 1,
  //         per_page: 10,
  //       };
  //       dispatch(getTransportList(obj2));

  //       setFormInputs({
  //         truckNo: "",
  //         driverName: "",
  //         driverContactNr: "",
  //         bunk: "",
  //         type: "",
  //         paymentMode: "",
  //         liters: "",
  //         price: "",
  //         totalAmount: "",
  //         // odometerReading: "",
  //         km: "",
  //         mileage: "",
  //         billDocument: "",
  //         oldReading: "",
  //         newReading: "",
  //         usageReading: "",
  //       });

  //       props.onHide();
  //     } else {
  //       // setErrorMsg('*'+ item?.message);
  //       toast.error(item?.message || "Please try again !!", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //     setDisabled(false);
  //   });
  // };

  //load intial data for vehicle history

  const handleSave = async () => {
    let obj = {
      data: { ...formInputs },
    };

    let obj2 = {
      ...getData,
      ...formInputs,
    };
    console.log(">>obj forminpust", obj);
    console.log(">>obj data", obj2);
    // setDisabled(true);

    try {
      // -------------------------------
      // 1️⃣ FIRST API CALL
      // -------------------------------
      const updateRes = await logistics.updateLogisticsTransport(obj2);

      if (!updateRes || updateRes.status !== 200) {
        toast.error(updateRes?.message || "Update failed");
        setDisabled(false);
        return;
      }

      // -------------------------------
      // 2️⃣ SECOND API CALL
      // -------------------------------
      const fuelRes = await ItemServiceV2.addLogisticsFuel(obj);

      if (fuelRes?.status === 200) {
        toast.success(fuelRes?.message || "Added successfully");

        dispatch(
          getOrderSchedulingList({
            queryName: "getFuelList",
            module: "CUSTOMER",
            page: 1,
            per_page: 10,
          })
        );

        dispatch(
          getTransportList({
            queryName: "getLogisticsTransportList",
            module: "",
            page: 1,
            per_page: 10,
          })
        );

        // Reset form
        setFormInputs({
          truckNo: "",
          driverName: "",
          driverContactNr: "",
          bunk: "",
          type: "",
          paymentMode: "",
          liters: "",
          price: "",
          totalAmount: "",
          km: "",
          mileage: "",
          billDocument: "",
          oldReading: "",
          newReading: "",
          usageReading: "",
        });

        props.onHide();
      } else {
        toast.error(fuelRes?.message || "Please try again !!");
      }
    } catch (error) {
      toast.error("Something went wrong !");
    } finally {
      setDisabled(false);
    }
  };

  const [getFuelHistory, setFuelHistory] = useState();

  const loadIntialData = async () => {
    if (formInputs?.truckNo !== "") {
      const obj = {
        documentNumber: formInputs?.truckNo,
      };
      await logistics.getTruckMasterDetail(obj).then((item) => {
        if (item?.status === 200) {
          setFuelHistory(item.data[0]?.fuelHistory);
        } else {
          // setErrorMsg('*'+ item?.message);
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
      });
    } else {
      // navigate(LogisticsConstants.LOGISTICS_MASTER_VEHICLE_LIST);
    }
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="lg"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Fuel Entery Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="pt-2 pb-4">
          <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
            <InputField
              className="inputBox"
              type="date"
              label="Filling Date"
              name="filledDate"
              id="filledDate"
              value={formInputs?.filledDate}
              onChange={handleInputChange}
              disabled={getEditmode}
            />
          </Col>

          <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
            <InputField
              className="inputBox"
              label="Truck No"
              placeholder=""
              name="truckNo"
              id="truckNo"
              value={formInputs?.truckNo || formInputs?.vehicleNr}
              // error={validation.truckNo || ""}
              // onChange={handleInputChange}
              disabled={true}
            />
          </Col>
          <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
            <InputField
              className="inputBox"
              label="Driver Name"
              placeholder=""
              name="driverName"
              id="driverName"
              // error={validation.driverName || ""}
              value={formInputs?.driverName || formInputs?.driverName1 || ""}
              // onChange={handleInputChange}
              disabled={true}
            />
          </Col>
          <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
            <InputField
              className="inputBox"
              label="Driver Contact Nr"
              placeholder=""
              name="driverContactNr"
              id="driverContactNr"
              // error={validation.driverContactNr || ""}
              value={formInputs?.driverContactNr || ""}
              onChange={handleInputChange}
              disabled={getEditmode}
            />
          </Col>
          <Col xs={12} md={6} lg={4} className="commLeftRightPadding">
            <ComboboxField
              label="Bunk Name"
              placeholder=""
              data={bunk}
              id=""
              iconClassName="dropdownIcon"
              name="bunk"
              code="bunkCode"
              description="bunkDesc"
              setValue={formInputs?.bunk}
              getvalue={setDropdownData}
              // required={true}
              // error={validation.country}
              disabled={getEditmode}
            />
          </Col>
          <Col xs={12} md={6} lg={4} className="commLeftRightPadding">
            <ComboboxField
              label="Fuel Type"
              placeholder=""
              data={FuelType}
              id=""
              iconClassName="dropdownIcon"
              name="fuelType"
              code="fuelTypeCode"
              description="fuelTypeDesc"
              setValue={formInputs?.fuelType}
              getvalue={setDropdownData}
              required={true}
              // error={validation.country}
              disabled={getEditmode}
            />
          </Col>
          <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
            <InputField
              className="inputBox"
              label="Liters"
              type="number"
              name="liters"
              id="liters"
              // error={validation.liters || ""}
              value={formInputs?.liters || ""}
              onChange={handleInputChange}
              // required={true}
              disabled={getEditmode}
            />
          </Col>
          <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
            <InputField
              className="inputBox"
              label="Fuel Price"
              type="number"
              name="price"
              id="price"
              // error={validation.price || ""}
              value={formInputs?.price || ""}
              onChange={handleInputChange}
              // required={true}
              disabled={getEditmode}
            />
          </Col>
          <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
            <InputField
              className="inputBox"
              label="Total Amount"
              placeholder=""
              name="totalAmount"
              id="totalAmount"
              value={formInputs?.totalAmount || ""}
              readOnly={true}
              disabled={true}
            />
          </Col>
          <Col xs={12} md={6} lg={4} className="commLeftRightPadding">
            <ComboboxField
              label="Payment Mode"
              placeholder=""
              data={PaymentMode}
              id=""
              iconClassName="dropdownIcon"
              name="paymentMode"
              code="paymentMode"
              description="paymentMode"
              setValue={formInputs?.paymentMode}
              getvalue={setDropdownData}
              required={true}
              // error={validation.country}
              disabled={getEditmode}
            />
          </Col>
          <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
            <InputField
              className="inputBox"
              label="Old Reading"
              name="oldReading"
              value={formInputs.oldReading}
              onChange={handleInputChange}
              disabled={getEditmode}
            />
            {/* <InputField
              className="inputBox"
        
              placeholder=""
              name="oldReading"
              id="oldReading"
              // error={validation.oldReading || ""}
              value={formInputs?.oldReading || ""}
              onChange={handleInputChange}
            /> */}
          </Col>
          <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
            <InputField
              className="inputBox"
              label="New Reading"
              name="newReading"
              value={formInputs.newReading}
              onChange={handleInputChange}
              disabled={getEditmode}
            />

            {/* <InputField
              className="inputBox"
              label="New Reading"
              placeholder=""
              name="newReading"
              id="newReading"
              // error={validation.newReading || ""}
              value={formInputs?.newReading || ""}
              onChange={handleInputChange}
            /> */}
          </Col>
          <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
            <InputField
              className="inputBox"
              label="Usage Reading"
              placeholder=""
              name="usageReading"
              id="usageReading"
              // error={validation.usageReading || ""}
              value={formInputs?.usageReading || ""}
              // onChange={handleInputChange}
              disabled={true}
            />
          </Col>
          <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
            <InputField
              className="inputBox"
              label="Mileage"
              placeholder=""
              name="mileage"
              id="mileage"
              value={formInputs?.mileage || ""}
              readOnly={true}
              disabled={true}
            />
          </Col>

          <Col xs={12} md={6} lg={4} className="commTopButtonRightLeftPadding">
            <InputField
              className="inputBox"
              label="Kilo Meter"
              placeholder=""
              name="km"
              id="km"
              // error={validation.km || ""}
              value={formInputs?.km || ""}
              onChange={handleInputChange}
              disabled={getEditmode}
            />
          </Col>
          <Col xs={12} md={12} lg={4} className="commLeftRightPadding">
            <FileUploadComponent
              id="billDocument"
              name="billDocument"
              label="Supporting Document"
              allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
              multiple={true} // Change to false for single file selection
              required={true}
              onSuccessUpload={onSuccessUploadDocumentType}
              value={formInputs?.billDocument || ""}
              disabled={getEditmode}
            />
          </Col>
          <Col xs={8} md={2} lg={2} className="commLeftRightPadding">
            {(formInputs?.billDocument && (
              <img
                src="assets/img/newIcons/attached-file.png"
                className="mt-1 attachmentIcon"
                alt="attachments"
                onClick={() => handleViewFile(formInputs?.billDocument)}
              />
            )) ||
              "--"}
          </Col>
        </Row>

        {getFuelHistory?.length > 0 && (
          <>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">FH</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Fuel History</span>
                      <span className="subHeaderTitle">
                        Fuel History Details{" "}
                      </span>
                    </Col>

                    {/* <Col xs={2} md={1} lg={1} className="">
                                                  <POCollabrationCommonFillter />
                                                </Col> */}
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={fuelHistoryColum}
                          data={getFuelHistory}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={
                          //   Constants.ROW_PER_PAGE
                          // }
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Modal.Body>
      {!getEditmode && (
        <Row className="my-4 ">
          <Col
            xs={2}
            md={{ span: 2, offset: 8 }}
            lg={{ span: 2, offset: 8 }}
            className="d-flex justify-content-end mt-2"
          >
            <button
              className="btn btnTable btn-danger"
              variant="secondary"
              onClick={handleCancle}
            >
              Close
            </button>
          </Col>
          <Col xs={2} md={2} lg={2} className="d-flex justify-content-end mt-2">
            <button
              className="btn btnTable"
              variant="secondary"
              onClick={handleSave}
              disabled={disabled}
              // onClick={() => props.onHide()}
            >
              Save
            </button>
          </Col>
        </Row>
      )}
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </Modal>
  );
});

export default PlLogisticFuelEntryModal;
